
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-doctors/[...slug]",
      function () {
        return require("private-next-pages/best-doctors/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-doctors/[...slug]"])
      });
    }
  